//region :: Imports ::
import React, {ReactElement, ReactNode} from 'react';
import MComponent from '../Toolkit/Components/Component';
import {MCancelIconName, MOkIconName} from '../Toolkit/Icons';
import {DialogPositionType} from 'primereact/dialog';
import Dialog from '../Toolkit/Components/Controls/Dialog';
import MButton from '../Toolkit/Components/Controls/Button';
import MFormControl from '../Toolkit/Components/Controls/FormControl';
import {Enumeration} from '../Api/ControllerTypes/EnumerationTypes';
import MDropDownMulti from '../Components/Toolkit/DropDownMulti';

//endregion

/** */
type Props = {
    tmTypes: Enumeration[];
}

export type TaskData = {
    tmType: number[] | undefined;
}

/** */
type State = {
    position?: DialogPositionType;
    visible: boolean;
    workItemData: TaskData;
    onAddWork?: (data: TaskData) => void;
}

/** */
class AddTaskDialog extends MComponent<Props, State> {

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.initializeState();
    }

    /** */
    private bindMethods(): void {
        this.dialog_onHide = this.dialog_onHide.bind(this);

        this.getDialogTemplate = this.getDialogTemplate.bind(this);
        this.getFooterTemplate = this.getFooterTemplate.bind(this);
        this.ok_Click = this.ok_Click.bind(this);

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
    }

    /** */
    private initializeState(): void {
        this.state = {
            visible: false,
            workItemData: {
                tmType: [-1]
            },
        };
    }

    /** */
    private dialog_onHide(): void {
        this.safeSetState((draft: State) => draft.visible = false);
    }

    /** */
    public show(inputCallback: (data: TaskData) => void, position?: DialogPositionType) {
        this.safeSetState((draft: State) => {
            draft.position = position;
            draft.visible = true;
            draft.onAddWork = inputCallback;
            draft.workItemData = {
                tmType: [-1]}
        });
    }

    public hide() {
        this.safeSetState((draft: State) => {
            draft.visible = false;
        });
    }

    private ok_Click() {
        this.state.onAddWork!(this.state.workItemData!);
        this.hide();
    }

    private getDialogTemplate(): ReactNode {
        const tmTypes = this.props.tmTypes.map(tmType => ({
            value: tmType.id,
            label: tmType.name
        }))

        return (
            <div className="formgrid grid">
                <div className="col-12 md:col-12" style={{padding: "0px 0px 20px 0px"}}>
                    Select the work type to add to scheduled dates:

                </div>
                <div className="col-12 md:col-12">
                    <MFormControl label={'TM Type'}
                                  id={'tmType'}>
                        {(fieldClasses: string | undefined) => {
                            return (
                                <MDropDownMulti<number> id='tmTypeValue'
                                                        disabled={false}
                                                        items={tmTypes}
                                                        onChange={e =>
                                                            this.safeSetState(draft => draft.workItemData!.tmType = e)
                                }/>
                            );
                        }}
                    </MFormControl>
                </div>
            </div>);
    }

    private getFooterTemplate(): ReactNode {
        return (
            <div>
                <MButton label="OK"
                         color="success"
                         icon={MOkIconName}
                         disabled={!this.isUploadAvailable()}
                         onClick={this.ok_Click}/>
                <MButton label={'Cancel'}
                         icon={MCancelIconName}
                         disabled={false}
                         onClick={this.hide}/>
            </div>
        );
    }

    private isUploadAvailable() {
        return (this.state.workItemData.tmType?.length ?? 0) > 0 &&
            this.state.workItemData.tmType?.filter(t => t <= 0).length === 0;
    }

    /** */
    public render(): ReactElement {

        return (
            <React.Fragment>
                <Dialog title={'Add additional work'}
                        content={this.getDialogTemplate()}
                        icon={{name: 'pi pi-pencil', color: 'mcolor-info'}}
                        footer={this.getFooterTemplate()}
                        position={this.state.position}
                        canClose={false}
                        closeOnEscape={false}
                        visible={this.state.visible}
                        onHide={this.dialog_onHide}
                />
            </React.Fragment>

        );

    }

}

export default AddTaskDialog;
